import styled from '@emotion/styled';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link as LinkBase } from 'react-router';

import { PATH } from 'constants/RoutesConstants';
import { Row } from 'ui/base';

const Link = styled(LinkBase)`
  font-weight: 500;
`;

const Footer = ({ onClick }) => (
  <Row type="flex" justify="center" data-cy="notification-dropdown-view-all">
    <Link to={PATH.USER_NOTIFICATIONS.path} onClick={onClick}>
      <FormattedMessage id="notifications.dropdown.seeAll" defaultMessage="View all notifications" />
    </Link>
  </Row>
);

export default Footer;
